import { useEffect, useState } from 'react';
import { getDaysBetweenDates } from 'wisestep-base';

import { useWorkspaceSKUContext } from '../../context';

import NoticeUI from './NoticeUI';

const RenewalNotice = () => {
  const [days, setDays] = useState<number | null>(null);
  const workspaceSKU = useWorkspaceSKUContext();

  useEffect(() => {
    if (workspaceSKU.expiryDate) {
      const now = new Date();
      const diffValue = getDaysBetweenDates(now, new Date(workspaceSKU.expiryDate));
      setDays(diffValue);
    }
  }, [workspaceSKU.expiryDate]);

  return (
    <>
      {days != null && (
        <>
          {(workspaceSKU.workspacePlan?.planCode === 'TRIAL' ||
            workspaceSKU.workspacePlan?.planCode === 'PRM' ||
            workspaceSKU.workspacePlan?.planCode === 'STD') && <NoticeUI days={days} />}
          {days <= 7 &&
            (workspaceSKU.workspacePlan?.planCode === 'ENT' ||
              workspaceSKU.workspacePlan?.planCode === 'PRO') && <NoticeUI days={days} />}
        </>
      )}
    </>
  );
};
export default RenewalNotice;
